/**
 * This module only holds the list of ICE servers available
 * @module ICE
 */
export var servers = [{ urls: "stun:stun.l.google.com:19302" }];



//////////////////
// WEBPACK FOOTER
// ./src/ice.ts
// module id = 341
// module chunks = 1